import { TypeLink_external, TypeLink_internal } from '@/core/generated-types';
import { slugBuilder } from '@/core/contentfulConfig';
import { CONTENT_TYPE_LINK, defaultLocale } from '@/core/constants';

import buildShopSubdomainUrl from '@/utils/shopSubdomain';

export interface LinkWithContentType {
  sys: {
    contentType: {
      sys: {
        id: string;
      };
    };
  };
  fields: any;
}

export function buildLinkUrl(
  link?: LinkWithContentType,
  locale?: string,
): string {
  const isExternalLink =
    link?.sys.contentType.sys.id === CONTENT_TYPE_LINK.EXTERNAL;

  if (isExternalLink) {
    const externalLink = link as TypeLink_external;

    const linkUrl = externalLink.fields.linkUrl || '#';

    const hasShopSubdomain = externalLink.fields.hasShopSubdomain;

    if (locale) {
      // If it has shop subdomain, use the shop subdomain builder
      if (hasShopSubdomain) {
        return buildShopSubdomainUrl(linkUrl, locale);
      }

      // If the link URL starts with / and the locale is not the default locale, add the locale to the URL
      if (
        linkUrl.startsWith('/') &&
        !linkUrl.startsWith(`/${locale}`) &&
        locale !== defaultLocale
      ) {
        return `/${locale}${linkUrl}`;
      }
    }

    return linkUrl;
  } else {
    // Internal link - use slugBuilder
    return slugBuilder(link as TypeLink_internal);
  }
}

export function isExternalLink(link: LinkWithContentType): boolean {
  return link.sys.contentType.sys.id === CONTENT_TYPE_LINK.EXTERNAL;
}
